module.exports = __webpack_public_path__ + "img/weixin.35f4e207.png";